// extracted by mini-css-extract-plugin
export default {"component":"b1Bz4p","header":"c1Bz4p","headline":"d1Bz4p","arrowIcon":"e1Bz4p","tiles":"f1Bz4p"};